import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { DataToDelete } from "src/app/_metronic/core/classes/core.class";

@Injectable()
export class BoardService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    manageBoard(board) {
        return this.httpClient.post(`${this.apiUrl}/manageBoard`, board).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllBoard(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllBoard/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    bulkDeleteBoard(sectionIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteBoard/`, {
            DataToDelete: sectionIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }
    getBoardById(Id: number) {
        return this.httpClient.get(`${this.apiUrl}/getBoardById/` + Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllBoardName() {
        return this.httpClient.get(`${this.apiUrl}/getAllBoardName/`).pipe(
            map((response: any) => {
                return response
            })
        )
    }
    bulkInsert(boardData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportBoard`, boardData).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
}
